export class RouterConstants {
  public static readonly LOGIN = 'login';

  public static readonly BOARD_REGISTER = 'board/register';
  public static readonly BOARD = 'board';
  public static readonly BOARD_UNREGISTER = 'unregister';

  public static readonly TEACHER = 'teacher';
  public static readonly TEACHER_CLASS = 'class';
  public static readonly TEACHER_CONTENTS = 'contents';
  public static readonly TEACHER_RESULTS = 'results';
  public static readonly TEACHER_HOMEWORKS = 'homeworks';
  public static readonly TEACHER_CONTENT_LIBRARY = 'content-library';

  public static readonly MENTOR_TASKS = 'mentor-tasks';

  public static readonly SCHOOL_ADMIN = 'schooladmin';
  public static readonly SCHOOL_ADMIN_TEACHERS = 'teachers';
  public static readonly SCHOOL_ADMIN_STUDENTS = 'students';
  public static readonly SCHOOL_ADMIN_CLASSES = 'classes';
  public static readonly SCHOOL_ADMIN_SUBJECTS = 'subjects';
  public static readonly SCHOOL_ADMIN_CLASS_MANAGER = 'class-manager';

  public static readonly ADMIN = 'admin';
  public static readonly ADMIN_TEST = 'test';
  public static readonly ADMIN_USERS = 'users';
  public static readonly ADMIN_ADMINS = 'admins';
  public static readonly ADMIN_CLIENTS = 'clients';
  public static readonly ADMIN_INSTITUTIONS = 'institutions';
  public static readonly ADMIN_TEMPLATES = 'templates';
  public static readonly ADMIN_NOTIFICATIONS = 'notifications';
  public static readonly ADMIN_MONITORING = 'monitoring';
  public static readonly ADMIN_STATS = 'stats';
  public static readonly ADMIN_CLASS_MANAGER = 'class-manager';
  public static readonly ADMIN_LICENCES = 'licences';
  public static readonly ADMIN_SERVICE_FUNCTIONS = 'service-functions';
}
